import { render, staticRenderFns } from "./RevenueCenter.vue?vue&type=template&id=7f126e9a&scoped=true"
import script from "./RevenueCenter.vue?vue&type=script&lang=js"
export * from "./RevenueCenter.vue?vue&type=script&lang=js"
import style0 from "./RevenueCenter.vue?vue&type=style&index=0&id=7f126e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f126e9a",
  null
  
)

export default component.exports